import { useMutation, useQueryClient } from 'react-query';
import { updateReferralActivity } from '@/app/services/RMSService';

function useUpdateReferralActivityMutation() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ patientId, referralId, activityId, data }) => {
            return updateReferralActivity(patientId, referralId, activityId, data);
        },
        {
            onSuccess: async (_referralActivity, variables) => {
                /**
                 * Delete the cache for this so it will repull on its own.
                 */
                const queryPatientId = variables?.patientId;
                const queryReferralId = variables?.referralId;
                const queryActivityId = variables?.activityId;

                if (!queryPatientId || !queryReferralId || !queryActivityId) {
                    return;
                }

                queryClient.removeQueries([
                    'patient',
                    queryPatientId,
                    'referral',
                    String(queryReferralId),
                    'activity',
                    String(queryActivityId),
                ]);
            },
        }
    );
}

export default useUpdateReferralActivityMutation;
